<template>
  <div class="d-md-none">
    <!-- OUTIL DE RECHERCHE -->
    <SearchForm
      v-if="showSearch && $store.getters['user/isAuthenticated']"
      :searchConfig="searchConfig"
      class="m-3"
      @search="search($event)"
    />
    <ul class="nav nav-pills">
      <!-- BOUTONS NON-NORMALISES -->
      <template v-if="$store.getters['user/isAuthenticated']">
        <ApplicationHeaderLink
          v-for="(button, index) in customConnectedButtons"
          :buttonConfig="button"
          :key="index"
          @click.native="actionClick(button.action)"
        />
        <!-- BOUTON USER -->
        <ProfilLink
          v-if="showProfil"
          :profilConfig="profilConfig"
          @profilButtonClick="actionClick('profilButtonClick')"
        />
        <!-- BOUTON DECONNECTER -->
        <DisconnectLink
          v-if="showDisconnect"
          :disconnectConfig="disconnectConfig"
          @disconnect="$emit('disconnect')"
        />
      </template>
      <template v-else>
        <ConnectLink v-if="showConnect" :connectConfig="connectConfig" @connect="$emit('connect')" />
      </template>
    </ul>
  </div>
</template>

<script>
import SearchForm from "@clir/ApplicationHeader/Common/SearchForm";
import ApplicationHeaderLink from "./ApplicationHeaderLink";
import ProfilLink from "./ProfilLink";
import DisconnectLink from "./DisconnectLink";
import ConnectLink from "./ConnectLink";

export default {
  name: "BlocPriveConnected",
  props: {
    headerClass: { type: String, default: "" },
    disconnectConfig: { type: Object, default: () => {} },
    profilConfig: { type: Object, default: () => {} },
    searchConfig: { type: Object, default: () => {} },
    customConnectedButtons: { type: Array, default: () => [] },
    connectConfig: { type: Object, default: () => {} }
  },
  computed: {
    showDisconnect() {
      return this.getKey(this.disconnectConfig, "show", false);
    },
    showProfil() {
      return this.getKey(this.profilConfig, "show", false);
    },
    showProfilText() {
      return this.getKey(this.profilConfig, "showText", false);
    },
    profilTextClass() {
      return this.prefixStringKey(this.profilConfig, "textClass", {
        prefix: "fw-bold "
      });
    },
    showSearch() {
      return this.getKey(this.searchConfig, "show", false);
    },
    showConnect() {
      return this.getKey(this.connectConfig, "show", false);
    }
  },
  methods: {
    actionClick(action) {
      this.$emit(action);
    },
    search(searcherContent) {
      this.$emit("search", searcherContent);
    }
  },
  components: {
    SearchForm,
    ApplicationHeaderLink,
    ProfilLink,
    DisconnectLink,
    ConnectLink
  }
};
</script>